<template>
    <base-dblclick-input
      class="inline"
      model-type="contact"
      :model-id="clientContact.id"
      field-name="preferred_name"
      :field-value="clientContact.preferred_name"
      input-type="text"
      @refetch="fetchNewClients"
    ></base-dblclick-input>
  </template>
  
  <script>
    export default {
        name: "company-contact-preferred-name-cell"
    }
  
  </script>
  
  <script setup>
  import {defineProps, defineEmits} from "vue";
  
    const props = defineProps({
        clientContact: Object
    })
  
    const emit = defineEmits(['refetch-clients'])
  
    function fetchNewClients () {
        emit('refetch-clients')
    }
  
  </script>